// import Routing from "./routing";

export default class TourGroupForm {
    constructor(datePicker) {
        [this.datePicker] = datePicker.getCreatedDatepickers();

        // Registration type behaviour
        this.expectedArrivalBlock = document.querySelector("[id=expected-arrival-time-block]");
        this.preRegistrationType = document.querySelector("[id$=_tour_group_main_step_registrationType_0]");
        this.jumpInType = document.querySelector("[id$=_tour_group_main_step_registrationType_1]");
        this.inShopDate = document.querySelector("[id$=_tour_group_main_step_inShopDate]");
        if (this.preRegistrationType && this.jumpInType && this.expectedArrivalBlock) {
            this.preRegistrationType.onchange = this.handleRegistrationTypeBehaviour.bind(this);
            this.jumpInType.onchange = this.handleRegistrationTypeBehaviour.bind(this);
            this.handleRegistrationTypeBehaviour();
        }

        this.nationality = document.querySelector("[id$=_tour_group_nationality], [id$=_tour_group_main_step_nationality], [id$=_group_profile_nationality]");
        if (this.nationality) {
            this.provinces = document.querySelector("[id$=_tour_group_province], [id$=_tour_group_main_step_province], [id$=_group_profile_provinces]");
            this.nationality.onchange = this.changeNationality.bind(this);
            this.addButtons = document.querySelectorAll("td.add-rows");
            document.addEventListener("rowAdded", this.updateRow.bind(this));
        }
    }

    handleRegistrationTypeBehaviour() {
        if (this.jumpInType.checked) {
            this.expectedArrivalBlock.style.display = "none";
            this.datePicker.setDate(new Date());
            this.datePicker.setMaxDate(new Date());
        } else if (this.preRegistrationType.checked) {
            this.expectedArrivalBlock.style.display = "block";
            this.datePicker.setMaxDate(null);
        }
    }

    mapOptions(provinces) {
        this.provinces.innerHTML = "";
        this.provinces.appendChild(new Option());
        Object.entries(provinces).forEach((province) => {
            this.provinces.appendChild(new Option(province[1].Name, province[1].Code));
        });
        this.provinces.dispatchEvent(new Event("change"));
    }

    changeNationality() {
        fetch(`${this.nationality.dataset.provincesUrl}?${this.getQueryString({ q: this.nationality.value })}`, {
            credentials: "include",
        }).then((response) => {
            response.json().then((provinces) => {
                this.mapOptions(provinces);
            });
        }).catch((error) => {
            console.log(`There has been a problem with your fetch operation: ${error.message}`);
        });
    }

    updateRow(event) {
        const { target } = event;
        target.querySelector(`select[id$='countryOfResidence'] [value='${this.nationality.value}']`).selected = true;
        target.querySelector(`select[id$='nationality'] [value='${this.nationality.value}']`).selected = true;
    }

    getQueryString(params) {
        const esc = encodeURIComponent;

        return Object.keys(params)
            .map(k => `${esc(k)}=${esc(params[k])}`)
            .join("&");
    }
}
